// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".watermark-container{position:fixed;top:0;left:0;width:100%;height:100%;z-index:9999;pointer-events:none;overflow:hidden}.watermark-text{font-size:16px;line-height:26px;height:24px;white-space:nowrap;float:left;display:flex;align-items:center;justify-content:center}.watermark-text .watermark-rotate{display:inline-block;color:rgba(0,0,0,.1);transform:rotate(-35deg);-webkit-transform:rotate(-35deg)}", ""]);
// Exports
module.exports = exports;
